// extracted by mini-css-extract-plugin
export default {"vademecum":"styles_vademecum__W9zFd"};